import Attack from '../Attack/Attack';

export const unitTypes = [
  'HERO', 
  'WIZARD', 
  'PRIEST', 
  'INFANTRY',
  'CAVALRY',
  'MONSTER',
  'WAR MACHINE',
];

export const wardTypes = [
  'WARD (6+)', 
  'WARD (5+)', 
  'WARD (4+)',
];

export const wardMap = new Map([
  [wardTypes[0], '6+'],
  [wardTypes[1], '5+'],
  [wardTypes[2], '4+']
]);

export function getUnitsFromStorage(): Unit[] {
  const stored = localStorage.getItem('units');

  if(stored) {
    return JSON.parse(stored) as Unit[];
  }

  return [];
}

class Unit {
  public name: string;

  public unitSize: number;

  public health: number;
  public save: string;
  public control: number;

  public types: string[];
  public wardType: string;

  public pointCost = 0; //Points in different file

  public attacks: Attack[];

  constructor(
    name = 'Default', 
    unitSize = 5,
    health = 1,
    save = '6+',
    control = 1,
    types: string[] = [], 
    wardType = 'None', 
    attacks: Attack[] = []
  ) {
    this.name = name;

    this.unitSize = unitSize;
    
    this.health = health;
    this.save = save;
    this.control = control;

    this.types = types;
    this.wardType = wardType;

    this.attacks = attacks;
  }
}

export default Unit;